module.exports = fox._r("images/press/tsm-img-1.png", __webpack_public_path__ + "_/common/images/press/tsm-img-1.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/tsm-img-1.png
// module id = 412
// module chunks = 2